import { withProps } from '@cast/design-system';

import { MetricsBox } from 'components/boxes';

export const NetworkMetricsBox = withProps(MetricsBox, {
  titleProps: { variant: 'L10R' },
  primaryValueProps: { variant: 'h5' },
  valuesContainerProps: { gap: 6 },
});
